module.exports = {"TXTWCL_Each_Way":{"id":"TXTWCL_Each_Way","defaultMessage":"Gagnant/Placé"}}